import {
  CLEAR_ACCESS_CODE_CHALLENGE,
  DISPLAY_ACCESS_CODE_CHALLENGE,
  CLEAR_ACCESS_CODE_RESULT,
  DISPLAY_ACCESS_CODE_RESULT,
  FETCH_ACCESS_CODE_FAILURE,
  FETCH_ACCESS_CODE_REQUESTED,
  FETCH_ACCESS_CODE_SUCCESS,
  FLUSH_ACCESS_CODE_STATE,
} from 'actiontypes/accessCodes';

import {
  FACEBOOK_LOGIN_SUCCESS,
  GOOGLE_LOGIN_SUCCESS,
  LOGIN_SUCCESS,
  TWITTER_LOGIN_SUCCESS,
} from 'actiontypes/user';
import { IAccessCodesState } from 'types/accessCodes';


/**
 * Iniitial state
 * @type {Object}
 */
const INITIAL_STATE: IAccessCodesState = {
  isFetching: false,
  accessCode: {},
  challenge: {},
  active: false,
  result: {},
  displayChallenge: false,
  displayResult: false,
};

export default function reducer(state = INITIAL_STATE, action: { type: string, payload: any }) {
  const { payload = {} } = action;

  switch (action.type) {
    case FETCH_ACCESS_CODE_REQUESTED:
      return { ...state, isFetching: true };

    case FETCH_ACCESS_CODE_FAILURE:
      return { ...state, isFetching: false };

    case FETCH_ACCESS_CODE_SUCCESS:
      return {
        ...state,
        accessCode: payload,
        displayChallenge: true,
        isFetching: false,
      };


    case FLUSH_ACCESS_CODE_STATE:
      return INITIAL_STATE;

    case CLEAR_ACCESS_CODE_CHALLENGE:
      return {
        ...state,
        displayChallenge: false,
      };

    case DISPLAY_ACCESS_CODE_CHALLENGE:
      return {
        ...state,
        challenge: payload,
        displayChallenge: true,
      };

    case LOGIN_SUCCESS:
    case FACEBOOK_LOGIN_SUCCESS:
    case GOOGLE_LOGIN_SUCCESS:
    case TWITTER_LOGIN_SUCCESS:
      if (payload.accessCodeResult) {
        return {
          ...state,
          displayChallenge: false,
          displayResult: true,
          result: {
            message: payload.accessCodeResult.message,
            success: payload.accessCodeResult.isSuccess,
          },
        };
      }
      return state;

    case DISPLAY_ACCESS_CODE_RESULT:
      return {
        ...state,
        displayResult: true,
        result: {
          message: payload.message,
          success: payload.isSuccess,
        },
      };

    case CLEAR_ACCESS_CODE_RESULT:
      return {
        ...state,
        result: {},
        displayResult: false,
      };

    default:
      return state;
  }
}
